<template>
  <div class="t-parallax-bar">
    <div class="content">
      <div class="header" :style="styles.content">
        <div class="align-start">
          <slot name="start"/>
        </div>
        <div class="align-middle">
          <slot name='middle' />
        </div>
        <div class="align-end">
          <slot name="end"/>
        </div>
      </div>
      <div class="body" :style="styles.content">
        <slot name="body"/>
      </div>
    </div>
  </div>
</template>

<script>
import WaitImagesLoad from '@/mixins/wait-images-load'

export default {
  name: 't-parallax-bar',
  mixins: [WaitImagesLoad],
  props: {
    backgroundImage: String
  },
  computed: {
    images () {
      return {
        'BG': this.backgroundImage
      }
    },
    styles () {
      return {
        content: {
          '--bg-image': `url(${this.images['BG']})`,
          '--bg-opacity': this.imageIsLoaded(this.images['BG']) ? 1 : 0
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
%section {
  display: flex;
  flex: 1 0;
  z-index: 1;
}
.t-parallax-bar {
  position: relative;
  overflow: hidden;
  background-color: var(--secondary);

  .content {
    width: 100%;
    overflow: hidden;
    color: var(--on-secondary);

    &:before {
      content: '';
      z-index: -1;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: var(--header);
    }

    &:after {
      content: '';
      z-index: -1;
      position: absolute;
      top: 100px;
      bottom: 100px;
      left: 50%;
      right: 0;
      background-image: var(--bg-image);
      opacity: var(--bg-opacity);
      transition: opacity 500ms cubic-bezier(0.0, 0.0, 0.2, 1);
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;

      @include for-size(desktop-up) {
        left: 320px;
        right: 320px;
        position: fixed;
      }
    }

    .header, .body {
      padding: 3%;

      @include for-size(phone-only) {
        padding: 8%;
      }

      @include for-size(desktop-up) {
        padding-left: 10%;
        padding-right: 10%;
      }
    }

    .header {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      position: relative;
      background-color: var(--header);
      box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);
      width: 100%;
      padding-top: initial;
      padding-bottom: initial;

      .align-start {
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-content: center;
        -ms-flex-order: -1;
        order: -1;
        height: 100%;
      }

      .align-middle {
        height: 100%;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: center;
      }

      .align-end {
        justify-content: flex-end;
        -ms-flex-order: 1;
        order: 1;
        flex-grow: 0;
      }

      @include for-size(desktop-up) {
        .align-start {
          width: 33%;
        }
        .align-middle {
          display: none;
        }
        .align-end {
          width: 67%;
        }
      }
    }

    .body {
      padding-top: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;

      @include for-size(desktop-up) {
        justify-content: stretch;
        align-items: stretch;
        flex-direction: row;

        & > * {
          width: 33%;
          display: flex;
          flex-flow: column nowrap;
          align-items: center;

          &:first-child {
            align-items: flex-start;
          }

          &:last-child {
            align-items: flex-end;
          }
        }
      }
    }
  }
}
</style>
